import { useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { useApiClient } from 'bff/ApiClientProvider';
import {
  ClientBankAccountsViewModel,
  ClientDetailsGetClientBankAccountsRequest,
  ResultOfClientBankAccountsViewModel
} from 'bff/client';

export const useInvalidateBankDetails = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: ['BankAccounts'],
      refetchType: 'all'
    });
};

export const useBankAccountsQuery = (
  request: ClientDetailsGetClientBankAccountsRequest,
  isEnabled: boolean
): UseQueryResult<ClientBankAccountsViewModel | undefined, Error> => {
  const { clientDetailsApi } = useApiClient();

  return useQuery<
    ResultOfClientBankAccountsViewModel,
    Error,
    ClientBankAccountsViewModel | undefined
  >({
    queryKey: ['BankAccounts', request.clientId],
    queryFn: () => clientDetailsApi.clientDetailsGetClientBankAccounts(request),
    select: (response) => response.data,
    enabled: isEnabled
  });
};
